module.exports = __webpack_public_path__ + "img/ic_add-image.27ed6696.svg";